import { APP_CONSTANTS } from '~/common/explicit-exports';

export const CLC_SIGN_UP_METHODS: Record<string, string> = {
  [APP_CONSTANTS.ACADEMY_REGISTRATION_TYPES.AUTH_CODE]: 'Auth Code',
  [APP_CONSTANTS.ACADEMY_REGISTRATION_TYPES.INSTANT_AUTH_URL]: 'Instant Auth',
  [APP_CONSTANTS.ACADEMY_REGISTRATION_TYPES.INVITATION]: 'Invitation',
  [APP_CONSTANTS.ACADEMY_REGISTRATION_TYPES.SSO]: 'SSO',
  [APP_CONSTANTS.ACADEMY_REGISTRATION_TYPES.USERNAME_PASSWORD]: 'Username/Password',
};
